import React, { useState, useEffect } from 'react';
import Slide from './slide';
import Popup from './popup';
import Brand from './Brand';
import Comments from './Comments';
import img2 from './images/WHYUS01.png';
import Queryform from './Queryform';
import Satisfy from './Satisfy';
import Disclaimer from './Disclaimer';
import Testimonial from './testimonial';

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 3000); // popup after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <div className='mt-3'>
        <Slide />

        <div className="bg-dark text-light p-3 mt-2">
          <div className="container text-center">
            <h4 className="fw-bold mb-2">
              Empowering Ecommerce Success With E Seller Support
            </h4>
            <p className="mb-0">
              E Seller Support specializes in delivering comprehensive ecommerce solutions, specifically tailored to manage and optimize Amazon, Flipkart, and Meesho marketplaces.
            </p>
          </div>
        </div>

        <div className="container p-3">
          <div className="row align-items-center">
            <div className="col-sm-12 col-md-6 mb-4 mb-md-0">
              <h2 className="fw-bold mb-3">Why E Seller Support?</h2>
              <p>
                At E Seller Support, we are more than just providing services; we are a dedicated partner in your eCommerce success.
              </p>
              <p>
                With our in-depth expertise and proven track record, we offer customized Ecommerce Solutions that meet your unique business needs.
              </p>
              <p>
                Our comprehensive services are designed to maximize your marketing potential and increase your brand presence.
              </p>
              <p>
                Choose us for unmatched expertise, personalized service, and real business growth.
              </p>
            </div>

            <div className="col-sm-12 col-md-6 text-center">
              <img
                src={img2}
                className="img-fluid rounded shadow"
                alt="Why E Seller Support"
              />
            </div>
          </div>
        </div>

        <Brand />
        <Satisfy />
        <Comments />
        <Testimonial />
        <Queryform />
        <Disclaimer />
      </div>
      <Popup
  isOpen={showPopup}
  onClose={() => setShowPopup(false)}
/>

    </>
  );
};

export default Home;
